import { Input } from "@chakra-ui/react";

const CustomInput = ({ ...rest }) => {
  return (
    <Input
      bg="#E4DECD"
      borderColor="#E4DECD"
      borderWidth="1px"
      color="#73513C"
      type="text"
      boxShadow="none"
      fontFamily="FiraSansRegular"
      _placeholder={{
        color: "#73513C",
      }}
      height="60px"
      _focus={{
        boxShadow: "none",
        border: "1px solid #73513C",
      }}
      _hover={{
        boxShadow: "none",
        border: "1px solid #73513C",
      }}
      {...rest}
    />
  );
};

export default CustomInput;
